class Order {
    constructor(id, total_price, date, payment_method_id, shipped, shipping_paid) {
        this.id = id;
        this.total_price = total_price;
        this.date = date;
        this.payment_method_id = payment_method_id;
    }
}

class OrderItem {
    constructor(name, id, order_id, quantity, sold_price, condition, variant, base_image_url, type) {
        this.name=name;
        this.id = id;
        this.order_id = order_id;
        this.quantity = quantity;
        this.sold_price = sold_price;
        this.condition = condition;
        this.variant = variant;
        this.base_image_url = base_image_url;
        this.type = type;
    }
}

export {Order, OrderItem};